export default {
    pending: "Pending money",
    credits: "Approved funds",
    withdrawButton: "Withdraw",
};
